import React, { Suspense } from "react";

const Bar = React.lazy(() =>
  import("@ant-design/plots").then(module => ({ default: module.Bar }))
);

const BarChart = ({ config }) => {
  return (
    <Suspense fallback={<div>Loading chart...</div>}>
      <Bar {...config} />
    </Suspense>
  );
};

export default BarChart;
